
import './CodesExternesModal.css';
import React, { useEffect, useMemo, useRef, useState, useCallback } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { PrimaryBtnOutlineAction, SecondaryBtnOutlineAction, CancelBtnOutlineAction } from '../../../styles/Common';
import { useTheme } from 'styled-components';
import { TH, THead, TBody, Table, TD } from '../../../styles/Table.styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { EIFormCol, EIFormContainer } from '../../../containers/Entity/Entity.styled';
import { FormGroup, FormInput, FormLabel, TelInput, FormSelect } from '../../../styles/Common';
import { faCirclePlus } from '@fortawesome/free-solid-svg-icons'
import CancelIcon from '@mui/icons-material/Cancel';
import Axios from '../../../axios-proas'
import { EntContainer, EntContent, EntHeader, EntHeaderActions, EntHeaderTitle2, EntHeaderTitle, EntHeaderTitleDiv, EntFormList, EntHeaderWrapper, EIFormContainer2, EntFormItem, OptionDiv, OptionContainer } from '../../../containers/UserForm/UserForm.styled'
import { getNotyfObject } from '../../../shared/utility';
import SelectCodesExternes from '../../UI/SelectCodesExternes/SelectCodesExternes'
function CodesExternesModal({ show, modalClosed, title, data, codesInternes,uid, cancel}) {
    const {t} = useTranslation();
    const theme = useTheme()
    const [codesExternes, setCodesExternes] = useState([]);
    const [indexCodesExternesToDelete, setIndexCodesExternesToDelete] = useState(false);
    const notyf = getNotyfObject();
    const [errors, setErrors] = useState(null);

    const checkFormValidity = (codesToAdd, codesToUpdate,codesToDelete) => {

        let errors = []
        if (codesToAdd?.some(item => item.codeInterneId == null) || codesToUpdate?.some(item => item.codeInterneId == null)) { 
            errors.push( "Le code interne est vide ou non valide");
        }
      
        return errors;
    }


    const saveClickHandler = async () => {
        let codeExternesToDelete = codesExternes.filter(item => item.isToDelete) ?? []
        let codeExternesToAdd = codesExternes.filter(item => item.new && !item.id)??[]
        let codeExternesToUpdate = codesExternes.filter(item => item.isUpdate && item.id) ?? []
        var checkErrors = checkFormValidity(codeExternesToAdd, codeExternesToUpdate, codeExternesToDelete)
        if (checkErrors && checkErrors.length > 0) {
            setErrors(checkErrors);
        } else
        {
            setErrors([])
            try {
                const response = await Axios.post("/api/codeExternes/updatecodesexternes", {
                    codeExternesToDelete,
                    codeExternesToUpdate,
                    codeExternesToAdd
                });
                Axios.get("/api/campagnes/" + uid + "/codeexternes").then(res => {
                    
                    setCodesExternes(res?.data);
                   
                }).catch(response => {
                    notyf.error("Une erreur s'est produite")
                })
                notyf.success("Sauvegarde réussie");
                console.log("Sauvegarde réussie :", response.data);
            } catch (error) {
                notyf.error("Erreur lors de la sauvegarde");

                console.error("Erreur lors de la sauvegarde :", error);
            }
        }
    }

    const confirmeDeleteLevel = (index) => {
   
        let codesExternesTemp = codesExternes?.sort((a, b) => (!a.id && b.id ? -1 : a.id && !b.id ? 1 : (a.id ?? 0) - (b.id ?? 0)))
        if (codesExternesTemp[index].new == true) {
            let tempSteps = [...codesExternesTemp]
            tempSteps.splice(index, 1)
            setCodesExternes(tempSteps)
        } else {
            setCodesExternes((prevState) => {
                let newCodesExternes = [...codesExternesTemp]
                newCodesExternes[index] = { ...newCodesExternes[index], isToDelete: true }
                return newCodesExternes
            })
        }
           
    }
    
    const handleInputChange = (e,index) => {
        const key = e.target.name;
        var value = e.target.value;
        setCodesExternes((prevState) => {
            let newCodesExternes = [...prevState]
            newCodesExternes[index] = { ...newCodesExternes[index], [key]: value,isUpdate:true }
            return newCodesExternes
        })
        
    }
    const handleInputChangCodeInterne = (value, index) => {
        const key = "codeInterneId";
        console.log(value)
       console.log(index)
        setCodesExternes((prevState) => {
            let newCodesExternes = [...prevState]
            newCodesExternes[index] = { ...newCodesExternes[index], [key]: value, isUpdate: true }
            return newCodesExternes
        })

    }

    useEffect(() => {
        setCodesExternes(data)
    }, [data])

    const body = useMemo(() => codesExternes?.sort((a, b) => (!a.id && b.id ? -1 : a.id && !b.id ? 1 : (a.id ?? 0) - (b.id ?? 0)))
        .map((code, index) => (       
            <tr style={{ display: code.isToDelete?"none":"flex", width: "100%", justifyContent: "space-between" }} >
            <TD style={{ width: "5%", paddingTop: "5px" }}>
            </TD>
                <TD style={{ width: "15%", paddingTop: "5px" }}>                                  
                <FormGroup>
                    <FormInput
                        style={{ textAlign: "left" }}
                        id="codeReferentielClient"
                        type="text"
                        name="codeReferentielClient"
                        value={code?.codeReferentielClient || ""}
                        onChange={(e) => handleInputChange(e,index)}
                    />
                </FormGroup>
                    
                </TD>
                <TD style={{ width: "23%", paddingTop: "5px" }}>
                    <FormGroup>
                    <FormInput
                            style={{ textAlign: "left" }}
                            id="libelleReferentielClient"
                            type="text"
                            name="libelleReferentielClient"
                            value={code?.libelleReferentielClient || ""}
                        onChange={(e) => handleInputChange(e, index)}
                        />
                    </FormGroup>
                                           
                </TD>

                <TD style={{ width: "15%", paddingTop: "5px" }}>
                <FormGroup>
                    <FormInput
                        style={{ textAlign: "left" }}
                        id="ordreLad"
                        type="text"
                        name="ordreLad"
                        value={code?.ordreLad || ""}
                        onChange={(e) => handleInputChange(e, index)}
                    />
                </FormGroup>                                           
                </TD>
                <TD style={{ width: "21%", paddingTop: "5px" }}>
                <FormGroup>
                        <SelectCodesExternes value={code?.codeInterneId} index={index} onChange={handleInputChangCodeInterne} options={codesInternes} />
                    {/*<FormSelect*/}
                    {/*    id="codeInterneId"*/}
                    {/*    name="codeInterneId"*/}
                    {/*    value={code?.codeInterneId??""}*/}
                    {/*    onChange={(e) => handleInputChange(e,index)}*/}
                    {/*>*/}
                    {/*        <option key="in" value={""}></option>*/}
                    {/*    {*/}
                    {/*        codesInternes && codesInternes?.map(item => (*/}
                    {/*            <option key={item.id} value={item.id}>{item.libelle}</option>*/}
                    {/*        ))*/}
                    {/*    }*/}
                    {/*</FormSelect>*/}
                </FormGroup>
            </TD>
                <TD style={{ width: "15%" , paddingTop : "5px" }}>
                    <FormGroup>
                    <FormInput
                            style={{ textAlign: "left"}}                         
                            type="text"                        
                            value={code?.codeInterneId || ""}
                        />
                    </FormGroup> 
                    
                </TD>
            <TD style={{ width: "4%", paddingTop: "5px" }}>
                <CancelIcon onClick={(e) => confirmeDeleteLevel(index,codesExternes)} style={{ color: "#EE5A5A", cursor: "pointer", fontSize: "20px" }} />
                </TD>
            </tr>
            
       
        )), [codesExternes, indexCodesExternesToDelete])

    const addNewStep = (e) => {
        e.preventDefault();
        let p = { new: true, campagneId: uid, codeInterne: null, codeInterneId: null, codeReferentielClient: null, ordreLad: null, libelleReferentielClient: null};
        let codesExternesTemp = [...codesExternes];      
        codesExternesTemp.push(p);
        setCodesExternes(codesExternesTemp)
    }

    return (
        <>
            <Modal show={show} onHide={modalClosed} contentClassName="modal_w_mc_2" >
                <Modal.Header closeButton>
                <Modal.Title className="ICDBlue"> {title}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="ADMCreationModal__body" >

                    <EntHeaderWrapper>
                        <EntHeaderTitleDiv>
                            <EntHeaderTitle style={{ marginLeft: "10px" }} color={theme.colors.secondary}>Liste des codes externes
                           </EntHeaderTitle>
                        </EntHeaderTitleDiv>
                        <EntHeaderActions>
                            <PrimaryBtnOutlineAction
                                style={{ backgroundColor: theme.colors.success }}
                                bd={theme.colors.success}
                                onClick={saveClickHandler}
                            >
                                <span>Valider</span>
                            </PrimaryBtnOutlineAction>
                            <CancelBtnOutlineAction
                                color={theme.colors.danger}
                                border={theme.colors.danger}
                                onClick={() => cancel()}
                            >
                                Annuler
                            </CancelBtnOutlineAction>
                        </EntHeaderActions>
                    </EntHeaderWrapper>
                    {
                        errors && errors.length > 0 ? (
                            <div className="alert alert-danger mt-2" role="alert">
                                <ul>
                                    {
                                        errors.map(error => (<li key={error}>{error}</li>))
                                    }
                                </ul>
                            </div>
                        ) : null
                    }
                        <EIFormContainer>
                            <EIFormCol style={{ width: "95%", minWidth: "650px" }}>

                                <FormGroup bd={"#fff"}>
                                
                                    <Table style={{ marginTop: "10px" }}>
                                        <THead>
                                        <tr style={{ width: "100%", display: "flex", justifyContent: "space-between", paddingTop: "5px" }}>
                                            <TH style={{ width: "5%" }} > <FontAwesomeIcon icon={faCirclePlus}
                                                style={{ display: "flex", marginLeft: "5px", marginRight: "2px", color: "#2174b980", fontSize: "1.25rem" }}
                                                onClick={e => addNewStep(e)} />
                                            </TH>
                                            <TH style={{ width: "15%", background: '#8392AB', color: "#F1F4F9", paddingLeft: "8px" }}>Code client</TH>
                                            <TH style={{ width: "23%", background: '#8392AB', color: "#F1F4F9", paddingLeft: "8px" }}>Code externe libelle </TH>
                                            <TH style={{ width: "15%", background: '#8392AB', color: "#F1F4F9", paddingLeft: "8px" }}>ordre Lad</TH>
                                            {/*<TH style={{ width: "20%", background: '#8392AB', color: "#F1F4F9", paddingLeft: "8px" }}>Code interne</TH>*/}
                                            <TH style={{ width: "22%", background: '#8392AB', color: "#F1F4F9", paddingLeft: "8px" }}>Code interne libelle</TH>
                                            <TH style={{ width: "15%", background: '#8392AB', color: "#F1F4F9", paddingLeft: "8px" }}>Code interne Id</TH>
                                            <TH style={{ width: "5%" }} >
                                            </TH>
                                               
                                            </tr>
                                    </THead>
                                    <TBody style={{ maxHeight: "600px",overflow: 'auto',display: 'block'}}>
                                        {body}
                                    </TBody>

                                     
                                    </Table>
                                </FormGroup>

                            </EIFormCol>


                        </EIFormContainer>
                </Modal.Body>
                <Modal.Footer>


               

        
                    {/*<CancelBtnOutlineAction*/}
                    {/*    color={theme.colors.danger}*/}
                    {/*    border={theme.colors.danger}*/}
                    {/*    onClick={cancel}*/}
                    {/*>*/}
                    {/*    Fermer*/}
                    {/*</CancelBtnOutlineAction>*/}

                   

                </Modal.Footer>
            </Modal>
        </>
    )
}

export default CodesExternesModal

